import { AxiosInstance } from 'axios';

import { ServiceBaseConfig } from './Interfaces/IAccountService';

export interface CompanyLogoUploadResponse {
  success: boolean;
  data?: string;
}

export class CompanyLogoService {
  public static async uploadCompanyLogo(
    api: AxiosInstance,
    file: File,
    config: ServiceBaseConfig
  ): Promise<CompanyLogoUploadResponse> {
    const formData = new FormData();
    formData.append('logo', file);

    const { data } = await api.post('/companies/logos', formData, config);
    return data;
  }
}
